<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">已参与实习计划列表</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <el-tag>{{$refs.organDia?$refs.organDia.nodeArrName:''}}</el-tag>&nbsp;<el-button type="primary" @click="dialogOpen">选择</el-button>
        </el-form-item> -->
        <!-- <el-form-item :label="`${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_no" filterable clearable :placeholder="`请选择${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="计划状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择计划状态">
            <el-option v-for="item in $store.state.planStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="审核状态">
          <el-select v-model="formInline.apply_status" clearable placeholder="请选择审核状态">
            <el-option v-for="item in $store.state.applyStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="所属院系">
          <el-input v-model="formInline.structure_1" placeholder="请输入所属院系"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="日期">
          <el-date-picker v-model="formInline.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增实训计划</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="name" label="实训计划名称" width="160">
        </custom-table-column>
        <custom-table-column fixed prop="training_room_name" :label="`${$store.state.themeTitle}室名称`" width="160">
        </custom-table-column>
        <custom-table-column label="是否打分" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.score" style="color:var(--ligtGreen);">是</span>
            <span v-else style="color:var(--red);">否</span>
          </template>
        </custom-table-column>
        <custom-table-column label="计划状态" width="150" prop="status"  label-class-name="planStatus" :formatter="format_arr">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="院系" width="160">
        </custom-table-column>
        <custom-table-column prop="major" label="专业" width="160">
        </custom-table-column>
        <custom-table-column prop="class_name" label="班级" width="160">
        </custom-table-column>
        <custom-table-column prop="school_year" label="学年" width="80">
        </custom-table-column>
        <custom-table-column prop="school_term" label="学期" width="80">
        </custom-table-column>
        <custom-table-column prop="teacher" label="指导老师" width="100">
        </custom-table-column>
        <custom-table-column prop="start_time" label="开始时间" width="180">
        </custom-table-column>
        <custom-table-column prop="end_time" label="结束时间" width="180">
        </custom-table-column>
        <custom-table-column prop="desc" label="实训说明" width="180">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleLookScore(scope.row.id)" type="text" size="small">查看分数</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"  :title="title" :visible.sync="centerDialogVisible" width="746px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="实训计划名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入实训计划名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitForm('ruleForm')">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitForm('ruleForm')">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :close-on-click-modal="false"  title="实习计划成绩" :visible.sync="detailDialogVisible" width="706px">
      <div>
        <custom-table :data="tableData1" border style="width: 100%">
          <custom-table-column prop="item" label="条目">
          </custom-table-column>
          <custom-table-column prop="score" label="分数" width="100">
          </custom-table-column>
          <!-- <custom-table-column fixed="right" label="操作" width="80">
            <template slot-scope="scope">
              <el-button @click="handleTrainScore(scope.row.plan_id,scope.row.student_id)" type="text" size="small">打分</el-button>
            </template>
          </custom-table-column> -->
        </custom-table>
        <!-- <div class="pageLine">
          <PageLine :total='total1' ref="pageChild1" @getList="getList2"></PageLine>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible  = false">取 消</el-button>
        <!-- <el-button type="primary" @click="deleteTarinRoom">确 定</el-button> -->
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"  title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan,mixinFormatter],
  data() {
    
    return {
      detailDialogVisible: false,
      tableData1: [],
      classRooms: [],
      institutes: [],
      formInline: {
        status: '',
        apply_status: '',
      },
      ruleForm: {
        name: '',
        school_year: '',
        school_term: '',
        start_time: '',
        end_time: '',
        structure_1: '',
        major: '',
        class_name: '',
        training_room_name: '',
        training_room_no: '',
        teacher: '',
        teacher_number: '',
        desc: '',
      },
      rules: {
        name: [{ required: true, message: '请输入实训计划名称', trigger: 'blur' }],
        school_year: [{ required: true, message: '请选择学年', trigger: 'change' }],
        school_term: [{ required: true, message: '请选择学期', trigger: 'change' }],
        structure_1: [{ required: true, message: '请输入所属院系', trigger: 'blur' }],
        major: [{ required: true, message: '请输入专业', trigger: 'blur' }],
        class_name: [{ required: true, message: '请输入班级名称', trigger: 'blur' }],
        start_time: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        end_time: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        teacher: [{ required: true, message: '请输入指导教师', trigger: 'blur' }],
        teacher_number: [{ required: true, message: '请输入指导教师工号', trigger: 'blur' }],
        training_room_no: [{ required: true, message: `请选择${this.$store.state.themeTitle}室`, trigger: 'change' }],
        desc: [{ required: true, message: '请输入实训说明', trigger: 'blur' }],
      },
      type: 'add',
      tableName: '实训日志',
    };
  },
  created() {},
  mounted() {
    // this.getList();
    // this.$store.dispatch('getTarinMent');
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    async handleLookScore(plan_id) {
      this.detailDialogVisible = true;
      let res = await this.$api.query.getStudentScore({ plan_id });
      if (res.code == 0) {
        this.tableData1 = res.data;
      }
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    handleApply(plan_id) {
      // let str = '通过';
      // if (apply_status == 2) {
      //   str = '拒绝';
      // }
      this.$confirm(`此操作将报名该实训计划, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.applyStatus(plan_id);
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除',
          // });
        });
    },
    async applyStatus(plan_id) {
      let params = { plan_id };
      let res = await this.$api.update.studentApplyPlane(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          message: `报名成功!`,
        });
        this.handleQuery();
      }
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_room_name = this.$until.getLabelName(this.$store.state.trainRooms, 'training_no', 'training_name', e);
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteMethod(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      if (params.start_time) {
        let timee = params.start_time.getTime() / 1000;
        params.start_time = this.$until.getTimeStr(timee, '-');
      }
      if (params.end_time) {
        let timee = params.end_time.getTime() / 1000;
        params.end_time = this.$until.getTimeStr(timee, '-');
      }
      let res = await this.$api.creat.creatTrainPlan(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let timee = '';
      if (typeof params.lesson_time == 'string') {
        timee = new Date(params.lesson_time).getTime() / 1000;
        params.lesson_time = this.$until.getTimeStr(timee, '-');
      } else {
        timee = params.lesson_time.getTime() / 1000;
        params.lesson_time = this.$until.getTimeStr(timee, '-');
      }
      let res = await this.$api.update.updateClassPlan(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    // },
    submitForm(formName) {
      if (this.ruleForm.lesson_time) {
        this.ruleForm.lesson_time = new Date(this.ruleForm.lesson_time);
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createMethod();
          } else if (this.type == 'edit') {
            this.updateMethod();
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = {
        page: this.$refs.pageChild.page,
        size: this.$refs.pageChild.size,
      };
      if (this.formInline.status) {
        params.status = this.formInline.status;
      }
      // if (this.formInline.apply_status) {
      //   params.apply_status = this.formInline.apply_status;
      // }
      let res = await this.$api.query.getStudentPlanesed(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
